// Static product catalog (image + display metadata).
// Prices/descriptions come from the backend (/api/products) to prevent tampering.
export const PRODUCT_META = {
  pen_pal: {
    id: "pen_pal",
    title: "Seasonal Subscription Box",
    tagline: "Seasonal Subscription",
    subtitle: "Fresh styles and healthy hair for every season.",
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_girl-activity-hub/artifacts/b71imasz_file_00000000ed1881fab37c45532a64bc78.png",
    imageAlt:
      "Me Amor Seasonal Subscription Box — brush, comb, notebook & pen, scrunchies, claw clip, mirror and snap clips on a blush backdrop",
    intro:
      "Keep her hair routine fresh and exciting all year round! Our core favourite — colours and accessories change every few months to match the season's vibes, plus expert advice to keep her locks healthy.",
    whats_inside: [
      { label: "Brush", value: "1× Detangler brush & comb set (sized for age group)" },
      { label: "Accessories", value: "2–3× Ultra-soft satin scrunchies" },
      { label: "Extras", value: "1× Pack of snap clips or decorative ties" },
      { label: "Stationery", value: "1× Notebook & matching pen" },
      { label: "Mirror", value: "1× Mini pocket mirror" },
      { label: "Bonus guide", value: "Seasonal hair care tips — from summer sun to winter chill" },
    ],
    accent: "#C48B9F",
  },
  activity_kit: {
    id: "activity_kit",
    title: "Activity Box",
    tagline: "One-Time Gift Box",
    subtitle: "Organised, active and creative.",
    image:
      "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageAlt: "Delicate pink gift box tied with ribbon",
    intro:
      "Designed for the go-getters and creators! Whether she's heading to practice, diving into an art project, or journalling her thoughts, this box is perfect for everyday styling, self-reflection and fun.",
    whats_inside: [
      { label: "Brush", value: "1× Detangler brush & comb set (sized for age group)" },
      { label: "Stationery", value: "1× Bow notebook & matching pen set" },
      { label: "Accessories", value: "1× Large claw clip + 1–2× satin scrunchies" },
      { label: "Surprise", value: "2× Special gifts to spark extra joy and creativity" },
    ],
    accent: "#D4A373",
  },
  birthday_kit: {
    id: "birthday_kit",
    title: "Birthday & Spa Box",
    tagline: "One-Time Gift Box",
    subtitle: "The ultimate luxury pampering experience.",
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_girl-activity-hub/artifacts/dpgc245i_Untitled%20design_20260719_142611_0000.png",
    imageAlt:
      "Me Amor Birthday & Spa Box — satin sleep mask, pink hair bow, detangler brush, scrunchies, claw clips, plush heart and jewellery set",
    imageFit: "contain",
    imageBg: "#F9F1EF",
    intro:
      "Make her special day truly unforgettable! Packed with royal treatment vibes and premium satin bedding essentials designed to celebrate her and add a serious touch of luxury to her sleep and beauty routine.",
    whats_inside: [
      { label: "Brush", value: "1× Detangler brush & comb set (sized for age group)" },
      {
        label: "Luxury sleep & spa",
        value:
          "1× Satin pillowcase, 1× satin eye sleep mask, 1× mini pocket mirror",
      },
      {
        label: "Accessories",
        value: "1× Statement large pink satin hair bow + 1× large claw clip",
      },
      {
        label: "Bonus bling",
        value: "A premium mix of luxury satin scrunchies and snap clips",
      },
      { label: "Surprise", value: "1× Special birthday gift to make her celebration memorable" },
    ],
    accent: "#E1C6C1",
  },
  butterfly_collection: {
    id: "butterfly_collection",
    title: "Butterfly Collection",
    tagline: "Collectable",
    subtitle: "Confidence starts with the little things.",
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_girl-activity-hub/artifacts/wcwa873x_file_000000005e0481fa92565fd3a1a6bc16.png",
    imageAlt:
      "Me Amor Butterfly Collection on a lilac satin backdrop — cream drawstring gift bag with a printed pink butterfly, butterfly sticker sheet, pink pocket mirror with butterfly and floral design, satin pink and blue butterfly bow clips, lavender butterfly clips and butterfly-charm hair ties",
    imageFit: "cover",
    gallery: [
      {
        src: "https://customer-assets-eiarnc6j.emergentagent.net/job_girl-activity-hub/artifacts/wcwa873x_file_000000005e0481fa92565fd3a1a6bc16.png",
        alt: "Me Amor Butterfly Collection on a lilac satin backdrop — cream drawstring gift bag with a printed pink butterfly, butterfly sticker sheet, pink pocket mirror, satin pink and blue butterfly bow clips, lavender butterfly clips and butterfly-charm hair ties",
      },
      {
        src: "/bundle-hero.png",
        alt: "Me Amor Butterfly Collection styled alongside a Christmas Stocking Stuffer on a soft blush editorial backdrop with eucalyptus and dried grass",
      },
    ],
    intro:
      "The first release in our Me Amor Collectables range. Beautifully packaged in a reusable butterfly gift bag, each keepsake is filled with carefully chosen accessories she'll love to wear, collect and treasure. Perfect as a small gift, party favour, reward or stocking filler.",
    whats_inside: [
      { label: "Bag", value: "1× Reusable butterfly gift bag" },
      { label: "Brush", value: "1× Butterfly-themed hair brush" },
      { label: "Hair ties", value: "Butterfly hair ties" },
      { label: "Clips", value: "Butterfly clips" },
      { label: "Affirmation", value: "1× Me Amor affirmation card" },
      { label: "Surprise", value: "A butterfly-themed extra 🦋" },
    ],
    footnote:
      "Contents and colours may vary slightly — every collection is unique. Once they're gone, they won't be restocked.",
    badge: "Limited edition",
    accent: "#B48DBB",
  },
  christmas_stocking: {
    id: "christmas_stocking",
    title: "Christmas Stocking Stuffer",
    tagline: "Holiday · Collectable",
    subtitle: "A festive little keepsake, filled with love.",
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_girl-activity-hub/artifacts/ibyvp87r_file_00000000cd3081fa8c038195ed77483e.png",
    imageAlt:
      "Me Amor Christmas Stocking Stuffer — matching notebook and pen, keyring, affirmation card, mini mirror and satin scrunchies",
    imageFit: "cover",
    gallery: [
      {
        src: "https://customer-assets-eiarnc6j.emergentagent.net/job_girl-activity-hub/artifacts/ibyvp87r_file_00000000cd3081fa8c038195ed77483e.png",
        alt: "Me Amor Christmas Stocking Stuffer — matching notebook and pen, keyring, affirmation card, mini mirror and satin scrunchies on a festive backdrop",
      },
      {
        src: "/bundle-hero.png",
        alt: "Me Amor Christmas Stocking Stuffer paired with the Butterfly Collection gift bag on a soft blush editorial backdrop with eucalyptus and dried grass",
      },
    ],
    intro:
      "Our seasonal keepsake, styled for the holidays. A little bundle of joy she can open on Christmas morning — thoughtfully curated so every piece feels special. Perfect as a stocking filler, secret santa or party favour.",
    whats_inside: [
      { label: "Stationery", value: "1× Matching notebook & pen" },
      { label: "Keyring", value: "1× Charm keyring" },
      { label: "Affirmation", value: "1× Me Amor affirmations card" },
      { label: "Mirror", value: "1× Mini pocket mirror" },
      { label: "Accessories", value: "4× Satin scrunchies" },
    ],
    footnote:
      "Limited holiday release — flat $3 NZ-wide shipping when purchased on its own. Once they're gone, they're gone until next Christmas.",
    badge: "Holiday · Limited",
    accent: "#B23A48",
  },
  butterfly_stocking_bundle: {
    id: "butterfly_stocking_bundle",
    title: "Butterfly + Stocking Bundle",
    tagline: "Bundle · Save $2",
    subtitle: "Both keepsakes, gifted together.",
    // Editorial hero (used in cart drawer thumbnail); dedicated BundleStrip
    // renders the same photo full-width on the landing page.
    image: "/bundle-hero.png",
    imageAlt: "Butterfly + Stocking Bundle — linen butterfly gift bag with Christmas Stocking Stuffer mesh pouch of satin scrunchies, butterfly clip and Me Amor rose-logo tag",
    intro:
      "Pair our two limited-edition keepsakes — the Butterfly Collection and the Christmas Stocking Stuffer — and save $2. A double dose of Me Amor magic that's ready to give.",
    whats_inside: [
      {
        label: "Butterfly Collection",
        value:
          "Reusable butterfly gift bag with brush, hair ties, clips, affirmation card & surprise",
      },
      {
        label: "Christmas Stocking Stuffer",
        value:
          "Notebook & pen, keyring, affirmations card, mirror & 4× scrunchies",
      },
      { label: "Save", value: "$2 vs buying separately" },
    ],
    footnote:
      "Both items shipped together — flat $3 NZ-wide shipping. Limited holiday release only.",
    badge: "Save $2",
    accent: "#8E4A7B",
  },
};

export const PRODUCT_ORDER = [
  "pen_pal",
  "activity_kit",
  "birthday_kit",
  "butterfly_collection",
  "christmas_stocking",
];

// IDs that should NOT appear in the main product grid — rendered elsewhere.
export const HIDDEN_FROM_GRID = new Set(["butterfly_stocking_bundle"]);
